<div class="row p-2">
    <div class="col-3 col-sm-2">
        <img [src]="historyitem?.image">
    </div>

    <div class="col-9 col-sm-10">
        <p [appParagraph]="2" paragraphBold="true" class="d-flex align-items-center si-info-icon">
            {{historyitem?.header}}
            <ng-icon name="phosphorInfo" ngbPopover="{{historyitem?.popover}}" style="cursor:pointer;margin-left:.2rem"></ng-icon>
        </p>

        <p [appParagraph]="3">{{historyitem?.text}}</p>

        <div class="d-flex flex-nowrap">
            @for (subitem of historyitem?.subitems; track subitem) {
            <div class="pe-4">
                <img class="mb-2" [src]="subitem.image" width="48">
                <p [appParagraph]="3" class="text-uppercase" style="font-size:.7rem !important">{{subitem.header}}</p>
            </div>
            }
        </div>
    </div>
</div>
